/**
 * Provide a singleton that caches the user's connections and can be dependency injected into any view that needs them.
 */
import Backbone from 'backbone';

import UserPulseOxEnable from 'models/user/UserPulseOxEnable';

const globalUserPulseOxEnable = new UserPulseOxEnable();

export default globalUserPulseOxEnable;
